import { useEffect } from 'react'
import { useInterval } from '~shared/hooks/useInterval'
import GlobalStore from '../Stores/GlobalStore'

const HEARTBEAT_INTERVAL_MS = 60000

// Mounted only on the standalone entry branch (app.tsx), where the OIDC device
// token carries the kdsDeviceUid claim the endpoint needs. Embedded Admin
// sessions never render this, so they never beat. RUM records each request as a
// resource while the backend heartbeat remains the uptime source of truth.
export const DeviceHeartbeat = () => {
  useEffect(() => {
    void GlobalStore.recordHeartbeat()
  }, [])

  useInterval(() => {
    void GlobalStore.recordHeartbeat()
  }, HEARTBEAT_INTERVAL_MS)

  return null
}
